import React from 'react'
import { Link } from "react-router-dom";
import { ItemPost, itemPost } from '../../Post';
import { backgroundColorCounter } from '../style'
import { useTranslation } from 'react-i18next';


const Blog = ({items}) => {
    const { t } = useTranslation();
    return(
        <section className="knsl-p-0-80" style={backgroundColorCounter}>
          <img src="assets/img/palm.svg" className="knsl-deco-right" alt="palm" />
          <div className="container">
            <div className="row">
              <div className="col-lg-12">

                <div className="knsl-center knsl-title-frame knsl-scroll-animation knsl-mb-100">
                  <h2 className="knsl-mb-20">{t('main.newsletter')}</h2>
                  <p className="knsl-mb-30">{t('main.newsletterDesc')}</p>
                  <Link to="/blog" className="knsl-btn knsl-btn-md">{t('main.allPublications')}</Link>
                </div>

              </div>
              {items.map((item: ItemPost) => itemPost(item))}
            </div>
          </div>
        </section>
    )
}

export default Blog